import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { isPulseUser } from '../../../Utils/ConfigUtils';
import message from '../../../Containers/CandidateDrawer/messages';

function ComposeEmailAndMessageButton(props) {
  const {
    setComposeModalVisibility,
    activeTab,
    isDisabled,
    composeEmailType,
    setDefaultEmailTemplateValues,
    setCurrentReplyingToEmail,
    shouldChangeMailValues,
    setSubjectDisability,
    skEventName,
  } = props;

  let composeButtonName = '';
  if (activeTab === 'email') composeButtonName = <FormattedMessage {...message.composeEmailButton} />;
  else if (activeTab === 'workflow') composeButtonName = <FormattedMessage {...message.initiateWorkFlowLabel} />;
  else composeButtonName = <FormattedMessage {...message.composeTextButton} />;

  const isPulse = isPulseUser();

  useEffect(() => {
    if (composeEmailType) {
      setComposeModalVisibility(true);
    }
  }, [composeEmailType, setComposeModalVisibility]);

  const onClickComposeButton = async () => {
    setComposeModalVisibility(true);
    if (shouldChangeMailValues && activeTab === 'email') {
      await setSubjectDisability(false);
      setCurrentReplyingToEmail([]);
      setDefaultEmailTemplateValues();
    }
  };
  return activeTab === 'message' && isPulse ? null : (
    <div>
      <Button
        type="primary"
        shape="round"
        disabled={isDisabled}
        onClick={onClickComposeButton}
        sk-event-name={skEventName}
      >
        {composeButtonName}
      </Button>
    </div>
  );
}

export default ComposeEmailAndMessageButton;
